module.exports = __webpack_public_path__ + "img/event-slug.eec21ea5.svg";